// **React Imports
import React, { useContext, useMemo } from 'react'

// **MUI Imports
import { Box, Button, Typography } from '@mui/material'

// **Third party Imports
import moment from 'moment'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

// Context Imports
import { SettingsContext } from '../../context/setting'

// **Utils Imports
import { checkCurrentRole, checkDeveloperAccess } from '../../utils/utils'

// **SCSS Imports
import './index.scss'
import { ROLES } from '../../utils/constant'

const SubscriptionUpgradeAlert = () => {
  // Hooks
  const navigate = useNavigate()
  const location = useLocation()

  // Context
  const { settings } = useContext(SettingsContext)

  // Redux
  const currentlyActivePlan = useSelector(
    (state) => state.auth.currentlyActivePlan
  )

  // variables
  const remianingDays = useMemo(() => {
    const today = moment(currentlyActivePlan?.currentDate)
    const valideDate = moment(currentlyActivePlan?.validUntil)
    return valideDate.diff(today, 'days') || 0
  }, [currentlyActivePlan])

  const isDeveloper = useMemo(() => {
    return checkDeveloperAccess()
  }, [])

  const isAdmin = useMemo(() => checkCurrentRole(ROLES.ADMIN), [])

  const showPlanExpiryStrip = useMemo(() => {
    return !isDeveloper && !currentlyActivePlan
  }, [isDeveloper, currentlyActivePlan])

  return (showPlanExpiryStrip || currentlyActivePlan?.planName === 'Trial') &&
    !settings.hideSubscriptionStrap &&
    !location?.pathname?.startsWith('/subscription') ? (
    <Box className="subscription-upgrade-alert">
      <Box className="subscription-upgrade-alert-strap">
        {showPlanExpiryStrip ? (
          <Typography>Your plan has been expired. </Typography>
        ) : (
          <Typography className="prefix">
            {remianingDays > 1
              ? `Free trial will end in ${remianingDays} days`
              : remianingDays === 1
              ? 'Free trial will end soon'
              : 'Free trial ended!'}
          </Typography>
        )}
        {isAdmin && (
          <Button
            onClick={() => navigate('/subscription')}
            className="upgrade-plan-btn"
            variant="contained"
            size="small"
          >
            Upgrade now
          </Button>
        )}
      </Box>
    </Box>
  ) : (
    <></>
  )
}

export default SubscriptionUpgradeAlert
